import { useState, type FormEvent } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Brand, Button, Input, Alert, Card, FormStack } from "@marekl/adminer/components";
import { useLogin } from "../../auth/queries";
import { ApiError } from "../../lib/api";
import { getSafeReturnTo } from "../../auth/returnTo";
import styles from "./LoginPage.module.css";

export function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = getSafeReturnTo(searchParams.get("returnTo"));

  const { mutate: login, isPending, error } = useLogin();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    login(
      { username, password },
      { onSuccess: () => navigate(returnTo, { replace: true }) },
    );
  }

  function errorMessage(): string | undefined {
    if (!error) return undefined;
    if (error instanceof ApiError) {
      const body = error.body as { message?: string } | null;
      return body?.message ?? "Přihlášení selhalo.";
    }
    return "Neočekávaná chyba. Zkuste to prosím znovu.";
  }

  return (
    <div className={styles.page}>
      <Card className={styles.card}>
        <div className={styles.header}>
          <Brand />
          <p className={styles.subtitle}>Přihlášení</p>
        </div>

        <FormStack as="form" onSubmit={handleSubmit} noValidate className={styles.form}>
          {errorMessage() && (
            <Alert variant="err">{errorMessage()}</Alert>
          )}

          <Input
            id="username"
            label="Uživatelské jméno"
            type="text"
            autoComplete="username"
            autoFocus
            required
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />

          <Input
            id="password"
            label="Heslo"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button
            type="submit"
            variant="primary"
            block
            loading={isPending}
            disabled={!username || !password}
          >
            Přihlásit se
          </Button>
        </FormStack>
      </Card>
    </div>
  );
}
